import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useVariantsSelector = (id: string) => {
  const state = useGetEditOrActual();

  return useMemo(() => state.splitTests[id]?.variants, [id, state.splitTests]);
};
